import { Component, OnInit } from '@angular/core';
import { CorporateService } from '../corporate-service/corporate-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-fundingsource-configuration-list',
  templateUrl: './fundingsource-configuration-list.component.html',
  styleUrls: ['./fundingsource-configuration-list.component.css']
})
export class FundingsourceConfigurationListComponent implements OnInit {

  configurations: any = [];
  fundingSources: any = [];
  fundingSourceName = [];
  visiblePasswordId = null;
  search;

  constructor(private corporateService: CorporateService) { }

  ngOnInit() {
    this.getFundingSource();
  }

  getFundingSource() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fundingSources = data;
          this.fundingSourceName = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        this.getFundingSourceConfigurations();
      });
  }

  getFundingSourceConfigurations() {
    this.corporateService
      .getFundingSourceConfigurations()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.configurations = data;
        }
      });
  }

  togglePasswordVisibility(id) {
    this.visiblePasswordId = this.visiblePasswordId === id ? null : id;
  }

  ngOnDestroy(): void {
  }

}
